<script setup lang="ts">
import { ref } from "vue";
import { FormInst, NForm, NFormItem, NInput, NButton, FormRules, FormItemRule } from 'naive-ui';
import { UpdatePasswordType } from "@/ts/interfaces";
import { useUserPasswordUpdateStore } from "@/stores/client/update-password.store";


const formData = ref<UpdatePasswordType>({
  password: '',
  new_password: '',
  new_password_confirmation: ''
})

const userPasswordUpdateStore = useUserPasswordUpdateStore()

const passwordFormRef = ref<FormInst | null>(null)

const newPasswordRules : FormRules = {
  password: [{
    required: true,
    message: 'Password is required',
    trigger: ['input', 'blur']
  }],
  new_password: [{
    required: true,
    validator (rule: FormItemRule, value: string) {
      if (!value) {
        return new Error('New password is required')
      } else if (value === formData.value.password) {
        return new Error('New password has to be different than the current password')
      }

      return true
    },
    trigger: ['input', 'blur']
  }],
  new_password_confirmation: [{
    required: true,
    validator (rule: FormItemRule, value: string) {
      if (!value) {
        return new Error('New password confirmation is required')
      } else if (value !== formData.value.new_password) {
        return new Error('New password confirmation is not the same as new password')
      }

      return true
    },
    trigger: ['input', 'blur']
  }]
}
const submit = () => {
  passwordFormRef.value?.validate((errors) => {
    if (!errors) {
      userPasswordUpdateStore.edit(formData.value)
    }
  })
}
</script>

<template>
  <n-form ref="passwordFormRef" :model="formData" :rules="newPasswordRules">
    <div class="input-group">
      <label class="body-text-lg text-w-bold">
        Password
      </label>
      <n-form-item label="Password" path="password" :feedback="userPasswordUpdateStore.status === 2 ? userPasswordUpdateStore.errors?.errors?.password[0] : ''" :validation-status="userPasswordUpdateStore.status === 2 ? 'error' : 'success'">
        <n-input v-model:value="formData.password" size="medium" round placeholder="Type your current password" class="form-input" type="password" show-password-on="click"></n-input>
      </n-form-item>
    </div>

    <div class="input-group">
      <label class="body-text-lg text-w-bold">
        New Password
      </label>
      <n-form-item label="New Password" path="new_password">
        <n-input v-model:value="formData.new_password" size="medium" round placeholder="Type your new password" class="form-input" type="password" show-password-on="click">
        </n-input>
      </n-form-item>
    </div>

    <div class="input-group">
      <label class="body-text-lg text-w-bold">
        Confirm New Password
      </label>
      <n-form-item label="Confirm New Password" path="new_password_confirmation">
        <n-input v-model:value="formData.new_password_confirmation" size="medium" round placeholder="Confirm your new password" class="form-input" type="password" show-password-on="click">
        </n-input>
      </n-form-item>
    </div>

    <div class="button-container grid-x align-center">
      <div class="cell small-12 large-6">
        <n-button @click.prevent="submit" class="new-project-button" size="large" tabindex="0" :loading="userPasswordUpdateStore.status === 0">
          SAVE
        </n-button>
      </div>
    </div>
  </n-form>
</template>

<style lang="scss">
// Component Styles
</style>